import { menu } from './menu';
import { MenuCategory, Permissions, ROLES } from './types';

const haveAccess = (permissions: Permissions, roleName?: ROLES) => {
  if (roleName === ROLES.ADMIN) {
    return true;
  }
  if ('all' in permissions) {
    return true;
  }
  return !!roleName && permissions.roles.includes(roleName);
};

export const navigation = (roleName?: string) => {
  if (!roleName) {
    return [];
  }
  const _roleName = roleName as ROLES;
  return menu.reduce<MenuCategory[]>((acc, category) => {
    if (haveAccess(category.permissions, _roleName)) {
      acc.push({
        ...category,
        children: category.children.filter((item) =>
          haveAccess(item.permissions, _roleName)
        ),
      });
      return acc;
    }
    return acc;
  }, []);
};
